import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const user = {
  getDesk4meUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_DESK4ME
  },
  getClientIdDesk4me () {
    return store.getters['Client/clientIdDesk4Me']
  },
  getUserSettings () {
    return Axios.get(`/api/v1/user/configurations`)
  },
  saveUserSettings (settings) {
    return Axios.put(`/api/v1/user/configurations`, settings)
  },
  searchUsers (search) {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.public}/clients/${this.getClientIdDesk4me()}/users/search?searchFilter=${search}`)
  }
}
export default user
